import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useIsListClicked } from "Provider/HomeProvider";

const MAX_STAR_SIZE = 5;
interface StarsProps {
	count: number;
}
const Wrapper = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	${(props) => props.theme.event.disable};
`;

const StarWrapper = styled.ul``;

const StarList = styled.li<{ size: number; left: number; top: number; opacity: number }>`
	position: absolute;
	transform: translate(-50%, -50%);
	background-color: ${(props) => props.theme.color.white};
	border-radius: 100%;

	width: ${(props) => `${props.size}px`};
	height: ${(props) => `${props.size}px`};
	top: ${(props) => `${props.top}%`};
	left: ${(props) => `${props.left}%`};
	opacity: ${(props) => `${props.opacity}`};
`;

const Blur = styled.div<{ active: boolean }>`
	${(props) => props.theme.full_abs};
	height: 100%;
	backdrop-filter: blur(4px);
	opacity: ${(props) => (props.active ? 1 : 0)};
`;

const Stars: React.FC<StarsProps> = ({ count }) => {
	const { isListClicked } = useIsListClicked();
	const [data, setData] = useState(
		Array(count).fill({
			size: MAX_STAR_SIZE,
			position: {
				x: 0,
				y: 0
			},
			opacity: 1
		})
	);

	useEffect(() => {
		setData((n) =>
			n.map((el) => {
				return {
					...el,
					size: Math.round(Math.random() * MAX_STAR_SIZE),
					position: {
						x: Math.round(Math.random() * 100),
						y: Math.round(Math.random() * 100)
					},
					opacity: Math.random() * 0.5
				};
			})
		);
	}, []);

	return (
		<Wrapper>
			<StarWrapper>
				{data.map((el, index) => {
					return <StarList key={index} size={el.size} left={el.position.x} top={el.position.y} opacity={el.opacity} />;
				})}
			</StarWrapper>
			<Blur active={isListClicked} />
		</Wrapper>
	);
};

export default Stars;
